import { Routes } from '@angular/router';

export const authRoutes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login-v3/login-v3.component').then(m => m.LoginV3Component)
  },
  {
    path: 'notice-of-privacy',
    loadComponent: () => import('./pages/notice-privacy/notice-privacy.component').then(m => m.NoticePrivacyComponent)
  },
  {
    path: 'terms-and-conditions',
    loadComponent: () => import('./pages/terms-conditions/terms-conditions.component').then(m => m.TermsConditionsComponent)
  },
  { path: '**', redirectTo: 'login'}
];
